import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Klicke auf die Schaltfläche unten, um deine Zahlungsinformationen zu überprüfen und zu bestätigen.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Wir arbeiten mit Stripe zusammen, um Zahlungen abzuwickeln. Stripe ist die sicherste Zahlungsplattform, die von den größten Unternehmen weltweit genutzt wird.',
      form: {
        terms_acceptance: {
          label:
            'Indem Sie fortfahren, erklären Sie sich mit unserer <FoodAmigosTerms>Dienstleistungsvereinbarung</FoodAmigosTerms> und der <StripeTerms>Stripe Connected Account-Vereinbarung</StripeTerms> einverstanden.',
        },
      },
      labels: {
        stripe_requirements: 'Stripe braucht noch die folgenden Angaben oder konnte sie nicht bestätigen:',
        errors: 'Fehler',
        awaiting_verification: 'Dein Stripe-Konto wird überprüft',
        awaiting_verification_description:
          'Wir warten darauf, dass Stripe die Überprüfung deines Unternehmens abschließt. In der Zwischenzeit kannst du dein Profil einsehen.',
        details_hint:
          'Stripe gleicht Namen, Adressen und Telefonnummern mit amtlichen Daten ab. Ist eine Angabe falsch, korrigiere sie unter Meine Info → Persönliche Information, dann prüft Stripe sie erneut. Alles Weitere, was Stripe verlangt, kannst du in deinem Stripe-Profil ergänzen.',
        requirements_hint:
          'Einige davon sind Dokumente, zum Beispiel dein Ausweis: Lade sie im vorherigen Schritt „{{step}}“ hoch und komm dann hierher zurück.',
        requirements_hint_profile:
          'Einige davon sind Dokumente, zum Beispiel dein Ausweis: Lade sie in deinem Stripe-Profil hoch.',
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Inhaber',
          representative: 'Vertreter',
          business: 'Unternehmen',
        },
        details: {
          first_name: 'Vorname',
          last_name: 'Nachname',
          email: 'E-Mail',
          phone: 'Telefonnummer',
          dob: 'Geburtsdatum',
          id_number: 'Ausweisnummer',
          nationality: 'Staatsangehörigkeit',
          address: 'Straße und Hausnummer',
          city: 'Stadt',
          postal_code: 'Postleitzahl',
          state: 'Bundesland',
          country: 'Land',
          id_document: 'Ausweisdokument',
          proof_of_address: 'Adressnachweis',
          job_title: 'Position',
          business_name: 'Offizieller Firmenname',
          tax_id: 'Steuernummer',
          vat_id: 'USt-IdNr.',
          registration_number: 'Registernummer',
          website: 'Website',
          industry: 'Branche',
          product_description: 'Beschreibung deines Angebots',
          support_phone: 'Telefonnummer für den Kundensupport',
          owners: 'Bestätigung der Eigentümer',
          directors: 'Bestätigung der Geschäftsführer',
          executives: 'Bestätigung der leitenden Angestellten',
          registration_document: 'Nachweis der Unternehmensregistrierung',
          bank_account: 'Bankkonto für Auszahlungen',
          business_type: 'Unternehmensform',
          terms: 'Zustimmung zu den Bedingungen von Stripe',
          bank_account_proof: 'Nachweis über die Kontoinhaberschaft',
          tax_id_document: 'Nachweis der Steuernummer',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Für die Zahlungsabwicklung arbeiten wir mit Adyen zusammen. Adyen ist eine der sichersten Zahlungsplattformen, die von den größten Unternehmen weltweit genutzt wird.',
    },
  },
  labels: {
    verified: 'Dein {{paymentGateway}}-Konto ist verifiziert',
    verified_description:
      'Die Verifizierung von {{paymentGateway}} ist abgeschlossen. Du kannst dein Profil bei Bedarf weiterhin verwalten.',
  },
  buttons: {
    proceed: 'Bestätige meine Zahlungsinformationen',
    copy_link: 'Link kopieren',
    back: 'Zurück',
  },
  toasts: {
    something_went_wrong: 'Etwas ist schief gelaufen, bitte kontaktieren Sie den technischen Support',
  },
};
